
import React from 'react';
import { Phone, Clock } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import { CONFIG, TRANSLATIONS } from '../constants';

const TopBar: React.FC = () => {
  const { language } = useLanguage();
  const t = TRANSLATIONS[language];

  return (
    <div className="bg-[#0a0a0a] text-white py-2 px-4 md:px-8 flex justify-between items-center text-[10px] md:text-xs border-b border-gray-800 sticky top-0 z-[60] tracking-widest uppercase font-bold">
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2">
          <Phone className="w-3 h-3 text-[#c5a059]" />
          <span className="hidden sm:inline text-gray-400">{t.topBarPhone}</span>
          <a href={`tel:${CONFIG.phoneNumber.replace(/-/g, '')}`} className="hover:text-[#c5a059] transition-colors">
            {CONFIG.phoneNumber}
          </a>
        </div>
        <div className="hidden md:flex items-center gap-2 text-gray-400 border-l border-white/10 pl-6">
          <Clock className="w-3 h-3 text-[#c5a059]" />
          <span>Mon - Fri: 9:00 AM - 6:00 PM EST</span>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div className="text-[#c5a059] border border-[#c5a059]/30 px-2 py-0.5 rounded-sm">
          DMV AREA
        </div>
      </div>
    </div>
  );
};

export default TopBar;
